import { render } from "./ContactContent.vue?vue&type=template&id=36ba824e"
import script from "./ContactContent.vue?vue&type=script&lang=js"
export * from "./ContactContent.vue?vue&type=script&lang=js"

import "./ContactContent.vue?vue&type=style&index=0&id=36ba824e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__